/**
 * TemplateRenderDemoPanel — C011 템플릿 엔진 데모 (queue #646 §R646-2 항목7)
 * 고정 이메일 템플릿({{userName}} 님, {{resetLink}} …) + 사용자 변수 입력 → 렌더된 본문. 순수.
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTemplateRender } from '../../hooks/useTemplateDemo';
import { cardStyle, sectionTitleStyle, subtitleStyle, labelStyle, inputStyle, monoStyle, primaryButtonStyle, resultBoxStyle, DemoErrorState, DemoEmptyHint } from './demoShared';

const DEMO_TEMPLATE_KEY = 'password-reset-email';

export function TemplateRenderDemoPanel() {
  const { t } = useTranslation();
  const renderMutation = useTemplateRender();
  const [userName, setUserName] = useState('홍길동');
  const [resetLink, setResetLink] = useState('https://eraf.skax.co.kr/reset?token=demo');

  function handleRender() {
    renderMutation.mutate({ templateKey: DEMO_TEMPLATE_KEY, variables: { userName, resetLink } });
  }

  return (
    <section aria-labelledby="template-panel-title">
      <h2 id="template-panel-title" style={sectionTitleStyle}>{t('showcase.demo.template.title')}</h2>
      <p style={subtitleStyle}>{t('showcase.demo.template.subtitle')}</p>

      <div style={cardStyle}>
        <p style={{ ...monoStyle, fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)', marginBottom: 'var(--spacing-4)' }}>
          {/* queue #653 §R653-3: {{userName}}/{{resetLink}} 는 실제 렌더 대상이 아니라 템플릿
              문법 예시 리터럴이므로, i18next 가 오인터폴레이션하지 않도록 동일 플레이스홀더
              문자열을 옵션 값으로 되먹임(§R615 선례 준용 — 이중중괄호 리터럴 보존 패턴). */}
          {t('showcase.demo.template.previewText', {
            userNamePlaceholder: '{{userName}}',
            resetLinkPlaceholder: '{{resetLink}}',
          })}
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 'var(--spacing-3)', marginBottom: 'var(--spacing-4)' }}>
          <div>
            <label htmlFor="template-username" style={labelStyle}>userName</label>
            <input id="template-username" type="text" value={userName} onChange={(e) => setUserName(e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label htmlFor="template-resetlink" style={labelStyle}>resetLink</label>
            <input id="template-resetlink" type="text" value={resetLink} onChange={(e) => setResetLink(e.target.value)} style={inputStyle} />
          </div>
        </div>

        <button
          type="button"
          onClick={handleRender}
          disabled={renderMutation.isPending}
          aria-busy={renderMutation.isPending}
          style={{ ...primaryButtonStyle, opacity: renderMutation.isPending ? 0.6 : 1 }}
        >
          {renderMutation.isPending ? t('showcase.demo.template.rendering') : t('showcase.demo.template.renderButton')}
        </button>

        <div style={{ marginTop: 'var(--spacing-4)' }}>
          {renderMutation.isError && (
            <DemoErrorState title={t('showcase.demo.common.callFailed')} error={renderMutation.error} />
          )}
          {!renderMutation.isError && !renderMutation.data && <DemoEmptyHint text={t('showcase.demo.template.empty')} />}
          {renderMutation.data && !renderMutation.isError && (
            <div role="region" aria-label={t('showcase.demo.template.resultLabel')} style={resultBoxStyle}>
              <p style={{ margin: 0, fontSize: 'var(--font-size-sm)' }}>{renderMutation.data.rendered}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
